import { EyeIcon } from '@heroicons/react/24/outline';
import { Badge, Dropdown, Tooltip } from 'antd';
import { useState } from 'react';
import { ManageColumns } from './ManageColumns';
import { TFunction } from 'i18next';

interface ManageColumnsDropdownProps {
    t: TFunction;
    allColumns: { key: string; title: string }[];
    hiddenColumns: string[];
    setHiddenColumns: (keys: string[]) => void;
}

export const ManageColumnsDropdown = ({
    t,
    allColumns,
    hiddenColumns,
    setHiddenColumns,
}: ManageColumnsDropdownProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showManage, setShowManage] = useState(false);

    return (
        <div className="flex items-center justify-center gap-2">
            <Dropdown
                trigger={['click']}
                open={dropdownOpen}
                onOpenChange={(open) => setDropdownOpen(open)}
                placement="bottomRight"
                dropdownRender={() =>
                    showManage ? (
                        <div className="rounded-xl">
                            <ManageColumns
                                allColumns={allColumns}
                                hiddenColumns={hiddenColumns}
                                setHiddenColumns={setHiddenColumns}
                                onClose={() => {
                                    setShowManage(false);
                                    setDropdownOpen(false);
                                }}
                            />
                        </div>
                    ) : (
                        <></>
                    )
                }
            >
                <Tooltip title={t('buttons.manageColumns')}>
                    <Badge
                        className="flex items-center justify-center min-w-12"
                        count={
                            hiddenColumns.length > 0 ? hiddenColumns.length : 0
                        }
                        size="small"
                        offset={[-12, 4]}
                    >
                        <EyeIcon
                            className="w-5 h-5 cursor-pointer text-textPrimary"
                            onClick={() => {
                                setShowManage(true);
                                setDropdownOpen(true);
                            }}
                        />
                    </Badge>
                </Tooltip>
            </Dropdown>
        </div>
    );
};
